import clsx from "clsx";

export const Spinner = () => <span className="fas fa-cog fa-spin"></span>;

export const SpinnerBlock = (props: { className?: string }) => {
    const { className } = props;

    return (
        <div className={clsx("d-flex align-items-center", className)}>
            <Spinner />
        </div>
    );
};
